//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { ContentType, ContentCollection, Language } from '@constants'
import ChevronLeftIcon from 'vue-material-design-icons/ChevronLeft.vue'
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue'

const DOSSIER_ARTICLES = gql`
  query ($first: Int!, $where: DossierArticleFilterInput, $after: String) {
    dossierArticles(first: $first, where: $where, after: $after, order: { article: { date: DESC } }) {
      nodes {
        dossier {
          id
          externalId
          title
          slug
          description
          imageUrl
          language {
            locale
          }
        }
        article {
          id
          externalId
          date
          title
          slug
          abstract
          imageUrl
          redirectUrl
          edition {
            id
            name
          }
          country {
            id
            name
          }
          region {
            id
            name
          }
          contentType {
            id
            name
            colour
            contentTypeGroup {
              id
              name
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`

export default {
  name: 'Dossier',
  components: { ChevronRightIcon, ChevronLeftIcon },
  fetchOnServer: true,
  scrollToTop: true,
  data() {
    return {
      showPlaceholder: true,
      placeholders: 4,
      dossierArticles: [],
      articles: [],
      pagination: {
        total: 0,
        pageSize: 15,
        page: 1
      },
      ContentType,
      Language
    }
  },
  async fetch() {
    await this.refresh()
  },
  head() {
    const canonical =
      this.$config.baseURL +
      (this.dossier
        ? `/dossiers/${this.dossier.slug}--${this.dossier.externalId}`
        : `/dossiers/${this.titleSlug}--${this.queryId}`)

    return {
      title: this.dossier ? `${this.dossier?.title} - Telecompaper` : 'Telecompaper',
      meta: [
        { httpEequiv: 'content-language', content: this.dossier?.language?.locale ?? 'en' },
        { name: 'description', content: this.dossier?.description?.substring(0, 512) ?? '' },
        { name: 'og:description', content: this.dossier?.description?.substring(0, 512) ?? '' },
        {
          name: 'og:image',
          content: this.dossier?.imageUrl ? this.$img.getImage(this.dossier.imageUrl) : ''
        },
        { name: 'og:url', content: canonical },
        { name: 'og:title', content: this.dossier?.title ?? '' }
      ],
      link: [
        {
          rel: 'canonical',
          href: canonical
        }
      ]
    }
  },
  computed: {
    filters: sync('filters'),
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languageId() {
      return this.language === 'en' ? Language.ENGLISH : Language.DUTCH
    },
    queryType() {
      return this.$route.params.type
    },
    slugParts() {
      const slug = this.$route.params.slug.split('--')
      return slug
    },
    titleSlug() {
      return this.slugParts[0]
    },
    queryId() {
      return Number.parseInt(this.slugParts[this.slugParts.length - 1])
    },
    dossier() {
      return this.dossierArticles.length > 0 ? this.dossierArticles[0].dossier : null
    },
    currentBreakPoint() {
      return this.$store.get('app/currentBreakPoint') || 'md'
    }
  },
  watch: {
    languageId() {
      this.$router.push({ path: '/dossiers' })
    },
    'filters.options': {
      async handler() {
        this.pagination.page = 1
        await this.refresh()
      },
      deep: true
    }
  },
  beforeDestroy() {
    this.$nuxt.$off('onFiltersClear')
  },
  mounted() {
    this.setFilters({ isShow: true, enabled: false, showFilterTotal: false, header: this.titleSlug })
    this.$nuxt.$on('onFiltersClear', this.onFiltersClear)
  },
  methods: {
    async refresh() {
      if (Number.isNaN(this.queryId)) {
        this.$nuxt.error({ statusCode: 404, message: 'Not found' })
        return
      }

      this.showPlaceholder = true

      let after = null
      if (this.pagination.page > 1) {
        const id = this.pagination.pageSize * (this.pagination.page - 1) - 1
        after = this.encodeValue(id)
      }

      const where = {
        dossier: {
          externalId: {
            eq: this.queryId
          }
        },
        article: {}
      }

      if (this.filters.options.countryId != null) {
        where.article.country = {
          id: {
            eq: this.filters.options.countryId
          }
        }
      }
      if (this.filters.options.regionId != null) {
        where.article.region = {
          id: {
            eq: this.filters.options.regionId
          }
        }
      }
      if (this.filters.options.contentCollectionId != null) {
        where.article.contentCollectionArticles = {
          some: {
            contentCollectionId: {
              eq: this.filters.options.contentCollectionId
            }
          }
        }
      }
      if (this.filters.options.contentTypeId != null) {
        where.article.contentType = {
          id: {
            eq: this.filters.options.contentTypeId
          }
        }
      }
      if (this.filters.options.contentCollectionId !== ContentCollection.RESEARCH) {
        where.article.language = {
          id: {
            eq: this.languageId
          }
        }
      }

      if (Object.keys(where.article).length === 0) {
        where.article = null
      }

      try {
        const { data } = await this.$apollo.query({
          query: DOSSIER_ARTICLES,
          variables: {
            where,
            first: this.pagination.pageSize,
            after
          }
        })

        this.dossierArticles = data.dossierArticles.nodes
        this.articles = data.dossierArticles.nodes.map((x) => x.article)
        this.pagination.total = data.dossierArticles.totalCount

        if (this.dossier) {
          this.setBreadcrumb({
            isShow: true,
            pageCategory: this.$t('dossier.dossiers'),
            categoryRedirectUrl: `/dossiers`,
            pageTitle: this.dossier.title
          })

          this.filters.header = this.dossier.title
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showPlaceholder = false
      }
    },
    async onPaginationChange() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      await this.refresh()
    }
  }
}
